import React, { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";

import { API_GET_BOOKMAKERSETTINGS } from "../../../../utils/api/ApiConstant";
import { getAxios, putAxios } from "../../../Services/commonService";
import { Button, Input, Loading } from "../../";
import Icon from "../../../../assets/icons/Icon";

const BookmakerSettings = () => {
  const [finalData, setFinalData] = useState([]);
  const { isLoading, data: BookmakerSettingsData } = useQuery({
    queryKey: ["BookmakerSettingsData"],
    queryFn: async () =>
      await getAxios(API_GET_BOOKMAKERSETTINGS, {
        page: 1,
        limit: -1,
      }),
    staleTime: 300000,
  });
  console.log(
    "🚀 ~ BookmakerSettings ~ BookmakerSettingsData:",
    BookmakerSettingsData,
  );

  useEffect(() => {
    if (BookmakerSettingsData?.docs) {
      setFinalData(BookmakerSettingsData?.docs);
    }
  }, [BookmakerSettingsData]);

  const handleChange = (e, bookmaker) => {
    const { name, value } = e.target;
    const updatedData = finalData.map((row) =>
      row?._id === bookmaker?._id ? { ...row, [name]: value } : row,
    );
    setFinalData(updatedData);
  };

  const handleEdit = async (isAllUpdate, rowData) => {
    const url = isAllUpdate
      ? `${API_GET_BOOKMAKERSETTINGS}/updateAllBookmakerSetting`
      : `${API_GET_BOOKMAKERSETTINGS}/${rowData?._id}`;
    await putAxios(url, rowData);
  };

  return (
    <div className="table-responsive">
      <table className="report-card-box">
        <thead className="table-light">
          <tr>
            <th>No.</th>
            <th className="text-start">min stack</th>
            <th className="text-start">max stack</th>
            <th className="text-start">max profit</th>
            <th className="text-start">max loss</th>
            <th className="text-start">bet delay</th>
            <th className="text-start">min odds</th>
            <th className="text-start">max odds</th>
            <th className="text-start">max stake per odds</th>
            <th className="text-start">action</th>
          </tr>
        </thead>
        <tbody>
          {isLoading ? (
            <tr>
              <td colSpan="14" style={{ textAlign: "center" }}>
                <Loading />
              </td>
            </tr>
          ) : (
            finalData &&
            finalData.length > 0 &&
            finalData.map((bookmaker, i) => (
              <tr key={i}>
                <td>{i + 1}</td>
                <td className="text-start">
                  <Input
                    className="form-control"
                    name="minStack"
                    id="minStack"
                    type="number"
                    value={bookmaker?.minStack}
                    onChange={(e) => handleChange(e, bookmaker)}
                  />
                </td>
                <td className="text-start">
                  <Input
                    className="form-control"
                    name="maxStack"
                    id="maxStack"
                    type="number"
                    value={bookmaker?.maxStack}
                    onChange={(e) => handleChange(e, bookmaker)}
                  />
                </td>
                <td className="text-start">
                  <Input
                    className="form-control"
                    name="maxProfit"
                    id="maxProfit"
                    type="number"
                    value={bookmaker?.maxProfit}
                    onChange={(e) => handleChange(e, bookmaker)}
                  />
                </td>
                <td className="text-start">
                  <Input
                    className="form-control"
                    name="maxLoss"
                    id="maxLoss"
                    type="number"
                    value={bookmaker?.maxLoss}
                    onChange={(e) => handleChange(e, bookmaker)}
                  />
                </td>
                <td className="text-start">
                  <Input
                    className="form-control"
                    name="betDelay"
                    id="betDelay"
                    type="number"
                    value={bookmaker?.betDelay}
                    onChange={(e) => handleChange(e, bookmaker)}
                  />
                </td>
                <td className="text-start">
                  <Input
                    className="form-control"
                    name="minOdds"
                    id="minOdds"
                    type="number"
                    value={bookmaker?.minOdds}
                    onChange={(e) => handleChange(e, bookmaker)}
                  />
                </td>
                <td className="text-start">
                  <Input
                    className="form-control"
                    name="maxOdds"
                    id="maxOdds"
                    type="number"
                    value={bookmaker?.maxOdds}
                    onChange={(e) => handleChange(e, bookmaker)}
                  />
                </td>
                <td className="text-start">
                  <Input
                    className="form-control"
                    name="maxStackPerOdds"
                    id="maxStackPerOdds"
                    type="number"
                    value={bookmaker?.maxStackPerOdds}
                    onChange={(e) => handleChange(e, bookmaker)}
                  />
                </td>
                <td className="text-start">
                  <div className="action_icon_box">
                    <Icon
                      name="FaEdit"
                      className=" icon_button"
                      cursorPointer={true}
                      onClick={() => handleEdit(false, bookmaker)}
                    />
                    <Button
                      className="btn_main  "
                      onClick={() => handleEdit(true, bookmaker)}
                    >
                      U-A
                    </Button>
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default BookmakerSettings;
